import { ProcedureParamsHistorical } from '../../../../../shared/types/systemConfiguration/procedureParams';

export interface ProcedureHistoricalProps {
    historical: ProcedureParamsHistorical[];
    showHistorical?: boolean;
}

export const fieldEquivalences: { [key: string]: string } = {
    createdAt: 'Fecha de creación',
    name: 'Nombre',
    active: 'Activo',
    extra: 'Descripción',
};
